export const loginPaths = ['/login/[[...id]]']
export const publicPaths = [...loginPaths, '/redeem/[challenge]', '/mcp/login']

const adminOnlyPaths = [
  '/settings/workflows',
  '/settings/organisation',
  '/settings/forms',
  '/settings/__feature-flags',
  '/settings/core-data',
  '/settings/users-and-groups',
  '/settings/user-properties',
  '/settings/import',
  '/settings/ai',
  '/settings/security',
  '/settings/default-notifications',
  '/settings/user-properties',
  '/settings/import',
  '/settings/forms',
  'settings/dynamic-assignees',
  'settings/document-storage',
  'settings/admin',
]
export const isAdminPath = (pathname: string) => adminOnlyPaths.findIndex((adminPath) => pathname.startsWith(adminPath)) !== -1

const supplierPaths = ['/supplier-onboarding', ...publicPaths]
export const isSupplierPath = (pathname: string) =>
  pathname === '/' || supplierPaths.some((supplierPath) => pathname.startsWith(supplierPath))

const explicitSupplierPaths = ['/supplier-onboarding']
export const isExplicitSupplierPath = (pathname: string) =>
  explicitSupplierPaths.some((supplierPath) => pathname.startsWith(supplierPath))
